/*
 *
 * QualitativeQuestionList reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_QUALITATIVE_ANSWERS_WATCHER,
  GET_QUALITATIVE_ANSWERS_SUCCESS,
  GET_QUALITATIVE_ANSWERS_WORDCLOUD_WATCHER,
  GET_QUALITATIVE_ANSWERS_WORDCLOUD_SUCCESS,
  GET_QUALITATIVE_ANSWERS_SENTIMENT_WORDCLOUD_SUCCESS,
} from "./constants"
// El refetch standalone del bubble chart (containers/Reports/SentimentAnalysis,
// disparado desde containers/Report/Home/saga vía REFETCH_SENTIMENT_WORDCLOUD_WATCHER)
// también escribe en este mismo slice — necesita poner isLoadingSentimentWordcloud
// en true al arrancar, si no el loader nunca aparece en un refetch (solo en la
// primera carga, cuando arranca en true por el initialState).
import { REFETCH_SENTIMENT_WORDCLOUD_WATCHER } from "../../Report/Home/constants"

export const initialState = fromJS({
  isLoadingAnswers: true,
  answers: [],
  isLoadingWordCloud: true,
  wordCloud: [],
  isLoadingSentimentWordcloud: true,
  sentimentWordcloud: [],
  sentimentTotalAnswers: 0,
})

function qualitativeQuestionListReducer(state = initialState, action) {
  switch (action.type) {
    case GET_QUALITATIVE_ANSWERS_WATCHER:
      return state
        .set("isLoadingWordCloud", true)
        .set("isLoadingAnswers", true)
        .set("answers", [])
        .set("wordCloud", [])
        .set("isLoadingSentimentWordcloud", true)
        .set("sentimentWordcloud", [])
        .set("sentimentTotalAnswers", 0)

    case GET_QUALITATIVE_ANSWERS_SUCCESS:
      return state.set("isLoadingAnswers", false).set("answers", action.payload)

    case GET_QUALITATIVE_ANSWERS_WORDCLOUD_WATCHER:
      return state.set("isLoadingWordCloud", true)

    case GET_QUALITATIVE_ANSWERS_WORDCLOUD_SUCCESS:
      return state
        .set("isLoadingWordCloud", false)
        .set("wordCloud", action.payload)

    case GET_QUALITATIVE_ANSWERS_SENTIMENT_WORDCLOUD_SUCCESS:
      return state
        .set("isLoadingSentimentWordcloud", false)
        .set("sentimentWordcloud", action.payload.data || [])
        .set("sentimentTotalAnswers", action.payload.total_answers || 0)

    case REFETCH_SENTIMENT_WORDCLOUD_WATCHER:
      return state.set("isLoadingSentimentWordcloud", true)

    default:
      return state
  }
}

export default qualitativeQuestionListReducer
